import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';

export const MESSAGES_STORE_NAME = `messages`;

export type PlatformMessageBody = {
  Heading: string;
  Text: string;
};

export type PlatformMessage = {
  Id: number;
  Title: string;
  Start: string;
  End: string;
  Priority: number;
  IsUserDismissable: boolean;
  DisplayPath: string;
  Position: string;
  Style: string;
  IsActive: boolean;
  ReachEstimate: 0;
  ScheduleInfo: string;
  Body: PlatformMessageBody;
};

export interface IMessagesStore {
  unreadMessages: {
    count: number;
    hash: number;
  };
  platformMessages?: PlatformMessage[];
}

export const defaultMessagesStore: IMessagesStore = {
  unreadMessages: {
    count: 0,
    hash: 0
  }
};

export const createMessagesStore = (initialState: IMessagesStore) =>
  createSlice({
    name: MESSAGES_STORE_NAME,
    initialState,
    reducers: {
      storeReset: () => defaultMessagesStore,

      unreadMessagesUpdated: (store, action: PayloadAction<{ count: number; hash: number }>) => {
        store.unreadMessages.count = action.payload.count;
        store.unreadMessages.hash = action.payload.hash;
      },
      unreadPlatformMessagesUpdated: (store, action: PayloadAction<{ platformMessages: PlatformMessage[] }>) => {
        store.platformMessages = action.payload.platformMessages;
      }
    }
  });

export const { actions, reducer } = createMessagesStore(defaultMessagesStore);

export const createStore = (initialStore: IMessagesStore = defaultMessagesStore) =>
  configureStore({ reducer: { [MESSAGES_STORE_NAME]: createMessagesStore(initialStore).reducer } });

export const MessagesStore = createStore();
